export default "__VITE_ASSET__D7gwm4VI__"